import axios from "axios"
import { getUserInfoFromLocal } from './token'
import { getParameterByName } from './index'
import config from "../api/config"

//创建axios
const service = axios.create({
  //这里baseurl就是刚开始配置的开发环境和线上环境地址，webpack会自动读取无需手动再改
  baseURL: process.env.BASE_URL, //baseurl
  timeout: 15000 //请求超时
})

//request拦截
//请求拦截主要作用是验证请求是否合法，会带有用户token，这里模拟一个token，可以根据实际情况修改
service.interceptors.request.use(
  config => {
    return config
  },
  err => {
    // console.error(err)
    Promise.reject(err)
  }
)

const refreshToken = (oldToken) => {
  let account = getUserInfoFromLocal().emailOrPhone
  if (!account) return Promise.reject(new Error('Account is nil.'))

  return service.post(
    `${config.BASE_URL}/ThermometerV2/login-v3/login`,
    {
      emailOrPhone: account,
      authToken: oldToken
    }
  )
}

//响应拦截主要是对返回做统一处理
service.interceptors.response.use(
  response => {
    console.log(response)
    if (response.data.code === 200) {
      // 响应成功的结果
      return Promise.resolve(response.data)
    }
    if (response.data.code === 201) {
      // 响应 Token 过期
      let oldToken = getParameterByName('authToken', response.config.url || '')
      return refreshToken(oldToken).then(res => {
        const oriReq = response.config
        oriReq.url = oriReq.url.replace(oldToken, res.authToken)
        return service(oriReq)
      }).catch(err => {
        return Promise.reject(err)
      })
    }
    return Promise.reject(response.data)
  },
  error => {
    // console.log(JSON.stringify(error))
    if (error.response) {
      // 根据请求失败的http状态码去给用户相应的提示
      // if (error.response.status === 401) {
      //   // token或者登陆失效情况下跳转到登录页面，根据实际情况，在这里可以根据不同的响应错误结果，做对应的事。这里我以401判断为例
      //   router.push({
      //     path: `/login`
      //   })
      // }
      return Promise.reject(error)
    } else {
      return Promise.reject(new Error('请求超时, 请刷新重试'))
    }
  }
)

export default service
